import React from 'react';
import styled from 'styled-components';

import Tabs from 'antd/es/tabs';

import { DOOR_DETAILS_TABS } from '../constants';

const StyledTabs = styled(Tabs)`
  & .ant-tabs-nav {
    margin-bottom: 0;
    margin-top: -2px;

    & .ant-tabs-tab {
      padding: 10px 0;
    }
  }

  & .ant-tabs-nav::before {
    border-bottom: none;
  }

  & .ant-tabs-content-holder {
    display: none;
  }
`;

const DoorDetailsTabs = (props) => (
  <StyledTabs {...props}>
    {
      DOOR_DETAILS_TABS.entries().map(({ title, value }) => (
        <Tabs.TabPane key={value} tab={title} value={value} />
      ))
    }
  </StyledTabs>
);

export default DoorDetailsTabs;
